<script setup lang="ts">
withDefaults(defineProps<{
	isSelectable?: boolean;
	isSelected?: boolean;
}>(), {
	isSelectable: false,
	isSelected: false,

});
</script>

<template>
	<div
		class="group/cart-segments-wrapper relative rounded-3xl border-[3px] overflow-hidden w-full divide-y-[1px] transition-all duration-200"
		:class="[
			{ 'scale-105 border-green-300 hover:border-green-300': isSelected },
			{ 'border-gray-200': !isSelected },
			{ 'cursor-pointer hover:border-gray-400': isSelectable && !isSelected },
		]"
	>
		<div
			class="p-4 mobile:p-6 bg-gray-200 transition-all duration-200"
			:class="{
				'group-hover/cart-segments-wrapper:bg-gray-400': isSelectable && !isSelected,
				'group-hover/cart-segments-wrapper:bg-gray-200': isSelected,
			}"
		>
			<slot name="header" />
		</div>
		<div class="p-4 mobile:p-6 !border-0">
			<slot name="body" />
		</div>
		<div class="p-4 mobile:p-6">
			<slot name="footer" />
		</div>
	</div>
</template>
